<template>
  <b-modal :id="idModal ? idModal : 'modal-addedit-header-menu'" no-close-on-esc no-close-on-backdrop 
  >
    <template #modal-header>
      <div
        class="d-flex justify-content-between w-100 align-items-center"
      >
        <div class="w-100 d-flex align-items-center">
          <div @click="backManage()" style="font-size: 16px; color: #53585D;">
            <i class="fal fa-arrow-left cursor-pointer mr-gd-1"></i>
          </div>
          <TitleModal :label="`${action == 'add' ? $t('engine.manageHeader.widgetMenu.AddEditMenu.lblTitleAdd', languageEngine) : $t('engine.manageHeader.widgetMenu.AddEditMenu.lblTitleEdit', languageEngine)}`" />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="mr-gd-1 icon-hint">
          <i class="fal fa-question-circle"></i>
        </div>
        <div
          @click="backManage()"
          type="button"
          aria-label="Close"
          id="close-modal-add-header-menu"
          class="icon-close-modal"
        >
          <i class="fal fa-times"></i>
        </div>
      </div>

    </template>
    <template>
      <MenuName
        v-model="$v.data.properties.name.$model"
        :class="{ errors: $v.data.properties.name.$error }"
        :validate="$v.data.properties.name"
      />
      <FormGroupHorizontal 
        class="mt-gd-2"
        :label="$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuType', languageEngine)"
        :contentClass="{ errors: $v.data.properties.link.type.$error }"
        :split="'4:8'"
      >
        <NormalSelect
          class=""
          :selected="selectedType"
          :options="menuType"
          :optionValue="'value'"
          :optionLabel="'name'"
          :optionIcon="'icon'"
          :iconShow="true"
          :notMatchText="$t('engine.managePage.pageAddEdit.lblChoosePageType', languageEngine)"
          @change="onChangeMenuType"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal v-if="!$v.data.properties.link.type.required && $v.data.properties.link.type.$error"
        class="mt-5"
        :label="''"
        :split="'4:8'"
        :contentClass="'errors'"
      >
        <small>{{$t('engine.manageHeader.widgetMenu.AddEditMenu.errMenuTypeEmpty', languageEngine)}}</small>
      </FormGroupHorizontal>
    </template>
    <component
      :is="`${selectedType}`"
      :data="data.properties.link"
      :isChild="isChild"
      :isEnable="isEnable"
      :validate="$v.data.properties.link"
      class="mt-gd-2"
    />
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click.prevent="save($event)">
        <i class="far fa-check"></i> {{$t('engine.manageHeader.widgetMenu.AddEditMenu.lblBtnSave', languageEngine)}}
      </b-button>
      <b-button variant="default" @click="backManage()">
        <i class="far fa-times"></i> {{$t('engine.manageHeader.widgetMenu.AddEditMenu.lblBtnCancel', languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import MenuName from "./Input/MenuName";
import { capitalize } from "@helpers/text.helper";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

const url = helpers.regex("alpha", /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
const linkOpen = (value, vm) => {
  if (!vm.urlIsEnable || vm.type !== "url") return true;
  if (!value) {
    return false;
  }
  return true;
};
const typePageId = (value, vm) => {
  if (vm.type === "url") return true;
  if (!value) {
    return false;
  }
  return true;
};
const typeOnpage = (value, vm) => {
  if (vm.type !== "onpage") return true;
  if (!value) {
    return false;
  }
  return true;
};

const components = {
  url: () => import(/* webpackChunkName: "Url" */ "./Url/Url"),
  page: () => import(/* webpackChunkName: "Page" */ "./Page/Page"),
  onpage: () => import(/* webpackChunkName: "Anchor" */ "./Anchor/Anchor"),
};

const initMenuData = {
  type: "HEADER_MENU",
  id: "",
  version: "1",
  properties: {
    name: "",
    isEnable: true,
    link: {
      type: "",
      urlIsEnable: true,
      url: null,
      pageID: null,
      sectionPageID: null,
      sectionID: null,
      target: "_blank",
    },
  },
  componentsID: [],
};

export default {
  data() {
    return {
      data: this.getData(),
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
      siteComponents: "design/metadata/siteComponents",
      services: "design/page/services",
    }),
    menuType() {
      return [
        { value: "url", name: this.$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuTypeURL', this.languageEngine), icon: "far fa-link" },
        { value: "page", name: this.$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuTypePage', this.languageEngine), icon: "far fa-file" },
        { value: "onpage", name: this.$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuTypeAnchor', this.languageEngine), icon: "far fa-anchor" }
      ]
    },
    selectedType: {
      get() {
        return this.data.properties.link.type;
      },
      set(value) {
        this.data.properties.link.type = value;
        this.data.properties = {
          ...JSON.parse(JSON.stringify(this.data.properties)),
        };
      },
    },
  },
  components: {
    MenuName,
    FormGroupHorizontal,
    NormalSelect,
    TitleModal,
    ...components,
  },
  watch: {
    action() {
      this.data = this.getData();
    },
  },
  methods: {
    capitalize,
    getData() {
      let data_temp = { ...JSON.parse(JSON.stringify(initMenuData)) };
      if (this.action !== "add" && this.action) {
        data_temp = {
          ...JSON.parse(JSON.stringify(this.siteComponents[this.id])),
        };
      } else if ( this.action == 'add' ) {
        if ( this.pageId ) {
          // this.onChangeMenuType("page")
          data_temp.properties.link.type = "page"
          data_temp.properties.link.target = '_self'
          data_temp.properties.link.pageID = this.pageId;
        }
      }
      return data_temp;
    },
    onChangeMenuType(value) {
      this.selectedType = value
      if (value == 'page' || value == 'onpage') {
        this.data.properties.link.target = '_self'
      }
      if (value == 'url') {
        this.data.properties.link.target = '_blank'
      }
    },
    backManage() {
      this.$v.$reset();
      this.$emit("clear");
      if (this.$route.query.redirect_wb) {
        this.redirectToWb();
      } else {
        this.$bvModal.hide(`modal-addedit-header-menu`);
        this.$bvModal.show("modal-manage-header-menu");
      }
    },
    genCharacters(length) {
      var result = [];
      var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    genId() {
      var gen = "hmn" + this.genCharacters(4);
      const index = Object.keys(this.siteComponents).findIndex((i) => i == gen);
      if (index !== -1) gen = this.genId();
      return gen;
    },
    save(evt) {
      evt.preventDefault();
      delete this.data.show;
      this.$v.$touch();

      let newDataLink = this.data.properties.link
      
      // validate fail
      if (this.$v.data.properties.link.type.$invalid) { return; }
      if (this.$v.data.properties.name.$invalid) { return; }
      if (newDataLink.type == 'url' && newDataLink.urlIsEnable && this.$v.data.properties.link.url.$invalid) { return; }
      if (newDataLink.type == 'page' && this.$v.data.properties.link.pageID.$invalid) { return; } 
      if (newDataLink.type == 'onpage' && (this.$v.data.properties.link.pageID.$invalid || this.$v.data.properties.link.sectionID.$invalid)) { return; }

      // validate pass
      let oldDataLink
      if (this.action === "add") {
        oldDataLink = {
            type: "url",
            urlIsEnable: true,
            url: null,
            pageID: null,
            sectionPageID: null,
            sectionID: null,
            target: "_self"
          }
      } else {
        oldDataLink = this.siteComponents[this.id].properties.link
      }

      this.data.properties.link = this.genDataLinkForSave(oldDataLink, newDataLink)

      const id = this.action === "add" ? this.genId() : this.id
      if (this.action === "add") {
        let obj = {
          [id]: { ...JSON.parse(JSON.stringify(this.data)), id: id },
        };
        console.log("SAVE", obj);
        Object.assign(this.siteComponents, JSON.parse(JSON.stringify(obj)));
        this.siteComponents.HEADER_WIDGET_MENU.componentsID.push(id);
      } else {
        this.siteComponents[id] = {
          ...JSON.parse(JSON.stringify(this.data)),
        };
      }
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t(`engine.manageHeader.widhrTopMenu.AddEditMenu.msg${this.capitalize(this.action)}menuSuccess`,this.languageEngine)});
      this.$emit("scrollToMenu", id);
      this.backManage();
    },
    genDataLinkForSave(oldData, newData) {
      let result = oldData
      if (newData.type == 'url') {
        result.type = 'url'
        result.urlIsEnable = newData.urlIsEnable
        result.url = this.$v.data.properties.link.url.$invalid ? oldData.url : newData.url
        result.target = newData.target
      } else if (newData.type == 'page') {
        result.type = 'page'
        result.pageID = newData.pageID
        result.target = newData.target
      } else {
        result.type = 'onpage'
        result.pageID = newData.pageID
        result.sectionID = newData.sectionID
        result.target = "_self"
      }
      return result
    },
    redirectToWb() {
      window.location.href = this.services.webbuilderCmsUrl+`?${this.$route.query.redirect_wb}`;
    }
  },
  props: {
    id: {
      type: String,
    },
    action: {
      type: String,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    isEnable: {
      type: Boolean,
      default: true,
    },
    pageId: {
      type: String,
    },
    idModal: {
      type: String,
    }
  },
  validations: {
    data: {
      properties: {
        name: {
          required,
          maxLength: maxLength(50),
        },
        link: {
          type: {
            required,
          },
          url: {
            linkOpen,
            url,
          },
          pageID: {
            typePageId,
          },
          sectionID: {
            typeOnpage,
          },
        },
      },
    },
  },
};
</script>

<style lang="scss">
#modal-addedit-header-menu {
  .modal-header {
    padding: 16px 32px;
    display: flex;
    align-items: center;
    .icon-hint {
      font-size: 18px;
      width: 18px;
      height: 18px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
    .icon-close-modal {
      font-size: 24px;
      width: 16px;
      height: 24px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
  }
  .modal-body {
    padding: 16px 32px;
    font-family: Sarabun;
    font-size: 14px;
    color: #373E44;
  }
  .modal-footer {
    padding: 16px 32px;
  }
  .dropdown.b-dropdown.show {
    .btn.dropdown-toggle {
      border-color: #24bee2;
    }
  }
}
</style>
